import { useDispatch, useSelector } from 'react-redux';
import { selectFilterChanged } from '../model/selectors';
import {
  setChangedShutdownFilter,
  setVisibleShutdownFilter,
} from '../model/actions';

const useFilterVisible = () => {
  const dispatch = useDispatch();

  const filterChanged = useSelector(selectFilterChanged);

  const handleClose = () => {
    if (filterChanged) {
      //новый запрос с новыми фильтрами
    }

    dispatch(setVisibleShutdownFilter(false));
    dispatch(setChangedShutdownFilter(false));
  };

  const handleOpen = () => {
    dispatch(setChangedShutdownFilter(false));

    dispatch(setVisibleShutdownFilter(true));
  };

  return {
    onClose: handleClose,
    onOpen: handleOpen,
  };
};

export default useFilterVisible;
